"use strict";
/*
screen size breakpoint values come from `@kyruus/ui-theme`
{
  db_screen_xsmall: '420px',
  db_screen_small: '768px',
  db_screen_medium: '992px',
  db_screen_large: '1200px'
}
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUTTON_WIDTH = exports.VISIT_TYPE_CONTENT_HEIGHT = exports.HEADER_HEIGHT = exports.SIDEBAR_WIDTH = void 0;
exports.SIDEBAR_WIDTH = '18rem';
exports.HEADER_HEIGHT = '6rem';
exports.VISIT_TYPE_CONTENT_HEIGHT = '10rem';
exports.BUTTON_WIDTH = '8rem';
//# sourceMappingURL=breakpoints.js.map